// client/src/cmaRoutes.js — the CMA builder's screen (feature #4, 19 Oct 2026).
//   Dashboard:  /dashboard/cma   (list, builder ?id=, office settings ?tab=settings;
//                                 deep links ?new=1&client_id= / ?new=1&handoff_id=)
// API: /api/cma (routes/cma.js).
import React from 'react';
import { Route } from 'react-router-dom';
import CmaPage from './pages/secure/CmaPage';

/** Under /dashboard (staff login). */
export const cmaDashboardRoutes = () => [
    <Route key="cma" path="cma" element={<CmaPage />} />,
];
